<script setup>
import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination } from 'swiper/modules';

import NewsCard from '@/components/cards/NewsCard.vue';
import 'swiper/css';

import 'swiper/css/pagination';
import 'swiper/css/navigation';

import '@/assets/styles/swiper-custom.scss';
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const isLocked = ref(true);
const onSwiper = (swiper) => {
  isLocked.value = swiper.isLocked;
};

const onLockToggle = (swiper) => {
  isLocked.value = swiper.isLocked;
};
</script>
<template>
  <div
    class="news-slider"
    :class="[data?.background_color === 'black' ? 'white' : '']"
  >
    <h2
      v-if="data.title"
      class="mb-0 news-slider__title h2 text-center"
      data-aos="fade-up"
      data-aos-easing="ease-out-cubic"
      v-html="data.title"
    ></h2>
    <div class="news-slider__slider">
      <Swiper
        :slides-per-view="'auto'"
        :space-between="16"
        :modules="[Navigation, Pagination]"
        :navigation="{
          prevEl: '.news-slider__slider-navigation-prev',
          nextEl: '.news-slider__slider-navigation-next',
        }"
        :pagination="{
          el: '.news-slider__slider-pagination',
        }"
        data-aos="fade-up"
        data-aos-easing="ease-out-cubic"
        @swiper="onSwiper"
        @lock="onLockToggle"
        @unlock="onLockToggle"
      >
        <SwiperSlide v-for="(newsItem, index) in data.items" :key="index">
          <NewsCard
            :image="newsItem.image"
            :tags="newsItem.tags"
            :title="newsItem.title"
            :date="newsItem.date"
            :url="newsItem.url"
            :theme="data.background_color"
          />
        </SwiperSlide>
      </Swiper>
      <div
        v-show="!isLocked"
        class="swiper-pagination swiper-pagination--onblack news-slider__slider-pagination"
        data-aos="fade-up"
        data-aos-easing="ease-out-cubic"
      ></div>
      <div
        v-show="!isLocked"
        class="swiper-navigation news-slider__slider-navigation"
        data-aos="fade-up"
        data-aos-easing="ease-out-cubic"
      >
        <Button
          type="button"
          rounded
          variant="outlined"
          class="news-slider__slider-navigation-prev button-prev js-button-news-prev"
        >
          <CIcon
            class="button-prev__icon"
            :name="
              data?.background_color === 'black'
                ? 'direction-white'
                : 'direction-black'
            "
            width="16"
            height="16"
          />
        </Button>
        <Button
          type="button"
          rounded
          variant="outlined"
          class="news-slider__slider-navigation-next button-next js-button-news-next"
        >
          <CIcon
            class="button-next__icon"
            :name="
              data?.background_color === 'black'
                ? 'direction-white'
                : 'direction-black'
            "
            width="16"
            height="16"
          />
        </Button>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'sass:math';
.news-slider {
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__title {
    margin: 0;
    text-align: center;
  }
  &__slider {
    .swiper {
      height: 100%;
      overflow: visible;
      width: 100%;
      @include media-breakpoint-up(md) {
        overflow: hidden;
      }
    }
    .swiper-slide {
      align-self: stretch;
      height: auto;
      max-width: calc(100vw - 48px);
      width: 320px;
      @include media-breakpoint-up(sm) {
        max-width: unset;
        width: 356px;
      }
      @include media-breakpoint-up(md) {
        width: 389px;
      }
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(width, 389);
      }
    }
  }
}
</style>
